import { ErreurMessages } from './erreur-messages';

const erreurMessage = new ErreurMessages();

export class AjouterMessages {
  public choixFichier = 'ajouter.choix_fichier';
  public choixMultiFichier = 'ajouter.choix_multi_fichier';
  public documentComplementaire = 'ajouter.document_complementaire';
  public validerCreation = 'ajouter.valider.creation';
  public validerDemande = 'ajouter.valider.demande';
  public validerIdStructCompt = 'ajouter.valider.id_struct_compt';
  public validerNomCommercial = 'ajouter.valider.nom_commerical';
  public fichierVolumineux = erreurMessage.fichierVolumineux;
  public fichierMaximum = erreurMessage.fichierMaximum;

  constructor() {
  }
}
